import type { ProcessingDataClassification } from '@avisoma/shared/dist/ProcessingData';

export function classificationChartSize(classification: ProcessingDataClassification | undefined): number {
  return classification?.[0]?.[1]
    ? calculateSize(classification?.[0]?.[1], classification?.[1]?.[1])
    : 0;
}

function calculateSize(a: number | undefined = 0, b: number | undefined = 0) {
  const diff = Math.max((a - b) * 100, 0);
  const threshold = 10;

  return threshold * (diff / threshold);
}
